"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAnalyticsClient = void 0;

var tslib_1 = require("tslib");

var segment_1 = (0, tslib_1.__importDefault)(require("@analytics/segment"));

var dashboard_constants_1 = require("@hopin-team/dashboard-constants");

var provider_analytics_1 = require("@hopin-team/provider-analytics");

var createAnalyticsClient = function createAnalyticsClient() {
  return (0, provider_analytics_1.initAnalytics)({
    plugins: [(0, segment_1.default)({
      writeKey: (0, dashboard_constants_1.getSegmentKey)()
    })]
  });
};

exports.createAnalyticsClient = createAnalyticsClient;